import { forwardRef, ReactElement, useMemo } from 'react'
import { ContainerProps } from './props'
import { BackgroundContainer, StyledContainer } from './styles'

const Container = forwardRef<HTMLDivElement, ContainerProps>(
    (
        {
            background,
            children,
            fullWidth,
            maxWidth = 1200,
            onResize = undefined,
            onResizeCapture = undefined,
            ...props
        },
        ref
    ): ReactElement => {
        const widthCSS = useMemo(
            () => (!fullWidth ? { ...props.css, maxW: maxWidth } : props.css),
            [fullWidth, maxWidth, props.css]
        )

        const defaultContainer = (
            <StyledContainer
                {...props}
                onResize={onResize}
                onResizeCapture={onResizeCapture}
                css={widthCSS}
                ref={ref}
            >
                {children}
            </StyledContainer>
        )

        return background ? (
            <BackgroundContainer
                css={{ background: background }}
                onResize={onResize}
                onResizeCapture={onResizeCapture}
            >
                {defaultContainer}
            </BackgroundContainer>
        ) : (
            defaultContainer
        )
    }
)

Container.displayName = 'Container'

export default Container

export { BackgroundContainer, StyledContainer }
